// extracted by mini-css-extract-plugin
export var contentBody = "_aw-9";
export var headerImage = "_aw-2";
export var imageButton = "_aw-7";
export var imageButtonIcon = "_aw-8";
export var imageHeader = "_aw-4";
export var imageHeaderText = "_aw-5";
export var imageOverlay = "_aw-3";
export var imageTitle = "_aw-6";
export var imageWrapper = "_aw-1";
export var taskList = "_aw-a";
export var widget = "_aw-0";